import React from 'react';
import Link from 'gatsby-link'

const ChristmasNotification = () => {
  return (
      <div className="section">
          <div className="container">
              <div className="notification is-danger christmas-notification">
                  <h2 className="title"><i className="icon-christmas-tree" /> Kerstactie! <i className="icon-christmas-tree" /></h2>
                  <p>
                      Reserveer voor 10 december een photobooth tussen <strong>15 december - 27 december</strong> en ontvang gratis <strong>premium kerst props</strong> (t.w.v. &euro;25,-),
                      een <strong>op maat gemaakt frame</strong> (t.w.v. &euro;25,-) en alle foto's op <strong>luxe usb</strong> geleverd (t.w.v. &euro;25,-).
                  </p>
                  <br />
                  <Link className="button is-primary is-hidden-mobile" to="reserveren"> Reserveer direct een photobooth voor de kerst</Link>
                  <Link className="button is-primary is-hidden-tablet" to="reserveren"> Reserveer direct!</Link>
              </div>
          </div>
      </div>
  )
};

export default ChristmasNotification;


// WEBPACK FOOTER //
// ./src/components/notifications/christmasNotification.js